import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  rolePermissions: [],
  selectedRolePermissions: null,
  assignLoading: false,
};

const roleAccessSlice = createSlice({
  name: "roleAccess",
  initialState,
  reducers: {
    // Get Role Permissions
    getRolePermissionsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getRolePermissionsSuccess: (state, action) => {
      state.loading = false;
      state.rolePermissions = action.payload;
      state.error = null;
    },
    getRolePermissionsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Assign Role Permissions
    assignRolePermissionsStart: (state) => {
      state.assignLoading = true;
      state.error = null;
    },
    assignRolePermissionsSuccess: (state, action) => {
      state.assignLoading = false;
      // Update the role permissions for the specific role
      const { role_id, permissionIds } = action.payload;
      // Remove existing permissions for this role and add new ones
      state.rolePermissions = state.rolePermissions.filter(
        (item) => item.role_id !== role_id,
      );
      // The new permissions will be fetched again via get API
      state.error = null;
    },
    assignRolePermissionsFailure: (state, action) => {
      state.assignLoading = false;
      state.error = action.payload;
    },

    // Set Selected Role Permissions
    setSelectedRolePermissions: (state, action) => {
      state.selectedRolePermissions = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getRolePermissionsStart,
  getRolePermissionsSuccess,
  getRolePermissionsFailure,
  assignRolePermissionsStart,
  assignRolePermissionsSuccess,
  assignRolePermissionsFailure,
  setSelectedRolePermissions,
  clearError,
} = roleAccessSlice.actions;

export default roleAccessSlice.reducer;
